let colorArray = ['#000000', '#ffffff', '#00ff00', '#ff1493', '#008080', '#eee8aa', '#b22222', '#8470ff'];
export default colorArray;
